import { ApiVolumeArea } from './api-volume/ApiVolumeArea';
import { DataAccessView } from './access/DataAccessView';
import { DataSecurityApplicationOverview } from './DataSecurityApplicationOverview';
import { DataSecurityDashboard } from './DataSecurityDashboard';
import { DateRangePickerParams } from '@ui/DateRangePicker';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { FeatureRouteWrapper } from '@ui/features';
import { getPastDate } from '@sonar-software/sonar-ts-lib';
import { IntegratedAppsView } from './integrated-applications';
import { MonitorsView } from './monitors';
import React from 'react';
import { SetupAuditTrailViewArea } from './audit-trail/SetupAuditTrailView';
import { useQueryParams } from '@hooks';

import { BASE_ROUTES, PARAMS } from '@sonar-software/sonar-ts-constants';
import { Route, Routes, useLocation } from 'react-router-dom';

export type DataSecurityViewQueryParams = {
	appGroup?: number;
	dateRange: DateRangePickerParams;
	userSelectedGroup?: number;
};

export const DataSecurityView: React.FC = () => {
	const location = useLocation();
	const { queryParams, updateParams } = useQueryParams<DataSecurityViewQueryParams>({
		defaultParams: {
			dateRange: { start: getPastDate(7) }
		},
		transform: (newParams, params, combined) => {
			const { userSelectedGroup, ...rest } = combined;
			const appGroupFallback = params.appGroup === userSelectedGroup ? userSelectedGroup : undefined;

			return {
				...rest,
				appGroup: newParams.userSelectedGroup ?? rest.appGroup ?? appGroupFallback
			};
		}
	});

	return (
		<Routes>
			<Route
				element={
					<FeatureRouteWrapper feature={ FeatureFlag.DataSecurityDashboard }>
						<DataSecurityDashboard
							onViewChange={ updateParams }
							viewParams={ queryParams } />
					</FeatureRouteWrapper>
				}
				path='' />
			<Route
				element={
					<FeatureRouteWrapper feature={ FeatureFlag.DataSecurityDashboard }>
						<DataSecurityApplicationOverview
							key={ location.pathname }
							onViewChange={ updateParams }
							viewParams={ queryParams } />
					</FeatureRouteWrapper>
				}
				path={ PARAMS.ID } />
			<Route
				element={
					<FeatureRouteWrapper feature={ FeatureFlag.DataSecurityDashboard }>
						<ApiVolumeArea />
					</FeatureRouteWrapper>
				}
				path={ BASE_ROUTES.API_VOLUME } />
			<Route
				element={ <SetupAuditTrailViewArea /> }
				path={ BASE_ROUTES.SETUP_AUDIT_TRAIL } />
			<Route
				element={ <MonitorsView /> }
				path={ BASE_ROUTES.MONITORS } />
			<Route
				element={ <DataAccessView /> }
				path={ `${BASE_ROUTES.DATA_ACCESS}/*` } />
			<Route
				element={ <IntegratedAppsView /> }
				path={ `${BASE_ROUTES.APPLICATION_SETUP}/*` } />
		</Routes>
	);
};
